import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { TopDestinationItem } from './TopDestinationItem';
import { getTopDestinations } from '../../redux/topDestinations/actions';
import { getTopDestinationsSelector } from '../../redux/topDestinations/selectors';
import { LocationProp } from '../../models/Location';

export class TopDestinationsDesktop extends PureComponent {
    componentDidMount() {
        const { getTopDestinations } = this.props;
        getTopDestinations();
        this.trackPopularSuggestionsShown();
    }

    componentDidUpdate() {
        this.trackPopularSuggestionsShown();
    }

    trackPopularSuggestionsShown = () => {
        const { show, options, topDestinations, trackAutocompleteSourceState } = this.props;
        if (show && topDestinations.slice(0, options.sizeList).length > 0) {
            trackAutocompleteSourceState({
                source: 'popular',
                state: 'shown',
                queryLength: 0,
            });
        }
    }

    render() {
        const {
            show,
            onClickItem,
            options,
            topDestinations,
            trackAutocompleteSourceSelection,
        } = this.props;
        const topDestinationsToRender = topDestinations.slice(0, options.sizeList);
        return (
            <React.Fragment>
                { show && topDestinationsToRender.map((item, i) => (

                    <TopDestinationItem
                        key={item.id}
                        index={i}
                        item={item}
                        onClickItem={onClickItem}
                        trackAutocompleteSourceSelection={trackAutocompleteSourceSelection}
                    />
                ))}
            </React.Fragment>
        );
    }
}

TopDestinationsDesktop.propTypes = {
    getTopDestinations: PropTypes.func.isRequired,
    options: PropTypes.object,
    onClickItem: PropTypes.func.isRequired,
    topDestinations: PropTypes.arrayOf(LocationProp),
    show: PropTypes.bool,
    trackAutocompleteSourceState: PropTypes.func,
    trackAutocompleteSourceSelection: PropTypes.func,
};

TopDestinationsDesktop.defaultProps = {
    options: {
        sizeList: 3,
    },
    show: true,
    topDestinations: [],
    trackAutocompleteSourceState: () => {},
    trackAutocompleteSourceSelection: () => {},
};

const mapStateToPropsSelector = createStructuredSelector({
    topDestinations: getTopDestinationsSelector,
});

const ConnectedTopDestinations = connect(mapStateToPropsSelector, {
    getTopDestinations,
})(TopDestinationsDesktop);

ConnectedTopDestinations.propTypes = {
    id: PropTypes.number.isRequired,
};

export { ConnectedTopDestinations };
